import React, { forwardRef, useRef, useState } from "react";
import PropTypes from "prop-types";

import { useUniqueId } from "../hooks/useUniqueId";
import { validate, validationType } from "../../helper/validation";

import styles from "./GlobalFooterSignUp.scss";

const GlobalFooterSignUp = forwardRef((props, ref) => {
  const [isValidEmail, setIsValidEmail] = useState(true);
  const inputRef = useRef(null);
  const { children, changed, onFocus, onBlur, ...restProps } = props;
  const { id, name } = restProps;
  const inputId =
    id || `footer-input-${useUniqueId("GlobalFooter.SignUp", props) + 1}`;
  const inputName = name || inputId;

  const handleChange = () => {
    if (changed) {
      changed(inputRef);
    }
  };

  const handleBlur = (event) => {
    if (onBlur) {
      onBlur(event);
    }

    if (event.target.value.length) {
      const isValid = validate(
        validationType.mail,
        String(event.target.value).toLowerCase()
      );
      setIsValidEmail(isValid);
    } else {
      setIsValidEmail(true);
    }
  };

  const handleFocus = (event) => {
    if (onFocus) {
      onFocus(event);
    }
  };

  return (
    <div ref={ref} className={styles.container}>
      <input
        id={inputId}
        name={inputName}
        className={`${styles.input} ${!isValidEmail ? "is-invalid" : ""}`}
        ref={inputRef}
        onChange={handleChange}
        onBlur={handleBlur}
        onFocus={handleFocus}
        type="text"
        placeholder="Ihre E-Mail-Adresse"
        {...restProps}
      />
      <button type="submit" className={styles.button}>
        Anmelden
      </button>
      <label htmlFor={inputId} className={styles.label}>
        {children}
      </label>
      {!isValidEmail && (
        <p
          id={`${inputId}-msg`}
          className={`${styles["error-message"]} ${
            !isValidEmail ? "is-invalid" : ""
          }`}
        >
          Die E-Mail-Adresse ist ungültig.
        </p>
      )}
    </div>
  );
});

GlobalFooterSignUp.propTypes = {
  children: PropTypes.node,
  changed: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
};

GlobalFooterSignUp.defaultProps = {
  children: "E-Mail*",
  changed: null,
  onFocus: null,
  onBlur: null,
};

GlobalFooterSignUp.displayName = "GlobalFooter.SignUp";

export default GlobalFooterSignUp;
